import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import MainPagetitle from '../../layouts/MainPagetitle';
import { Modal, Button } from 'react-bootstrap';
import FuelService from '../../api/services/FuelService';

const EditFuel = () => {
  const params = useParams();
  const [error, setError] = useState("")
  const [fuel, setFuel] = useState([]);
  const [fuelModal, setFuelModal] = useState(false);
  const [isLoading, setisloading] = useState(true);
  useEffect(() => {
    var id = params.id;
    getFuelByID(id);
  }, []);

  const getFuelByID = async (id) => {
    try {
      let fuel = await FuelService.show(id).json();
      setFuel(fuel.data);
      setisloading(false);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
      }
      let responseData = await FuelService.update(params.id, userData).json()
      if (responseData.status === true) {
        setFuelModal(true)
      }
    } catch (error) {
      console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };


  return (
    <>
      <MainPagetitle mainTitle="Fuel" pageTitle={'Fuel'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Fuel</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmit}>
                  <div className="row">
                    <h5 style={{ color: 'red' }}>{error}</h5>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username"
                        defaultValue={
                          fuel.title
                            ? fuel.title
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder=""   defaultValue={
                          fuel.de_title
                            ? fuel.de_title
                            : ''
                        }/>
                    </div>

                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary mb-2 me-1"  >Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={fuelModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setFuelModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Fuel Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to={'/admin/fuel'} variant="danger light" onClick={() => setFuelModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditFuel;